import { useSelector } from 'react-redux';

/**
 * Marca de la empresa del usuario autenticado para el hero: portada + logo.
 *
 * Vive en un hook y no repetido en cada dashboard porque lo consumen TRES pantallas (inicio del
 * cliente, inicio sin plan y panel del gestor de bienestar) y la regla de cuándo aplica no puede
 * quedar distinta entre ellas.
 *
 * Devuelve `{ cover: null, logo: null }` cuando no corresponde, y con eso el hero cae solo al
 * degradado azulado de marca que ve todo el mundo:
 *  - usuario sin empresa;
 *  - empresa POR DEFECTO ("OTRIX App"), que es el cajón donde caen todos los que no pertenecen
 *    a ninguna empresa real: pintar su marca ahí se la pondría a toda la base de usuarios;
 *  - empresa real que todavía no subió ninguna imagen.
 */
const useOrganizationBranding = () => {
  const organization = useSelector((state) => state.auth.user?.organization);

  if (!organization || organization.is_default) {
    return { cover: null, logo: null, name: null };
  }

  return {
    cover: organization.cover_url || null,
    logo: organization.logo_url || null,
    name: organization.name || null
  };
};

export default useOrganizationBranding;
